import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MenuContent = styled(Stack)`
  @media (min-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    width: calc((((100vw - (11 * var(--gutter-24))) / 12) * 3) + (2 * var(--gutter-24)));
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    width: calc((((100vw - (11 * var(--gutter-24))) / 12) * 4) + (3 * var(--gutter-24)));
  }
`;
